export default __webpack_public_path__ + "static/media/1787.80996852.png";